import { VStack, Heading, Text, useTheme } from '@frontend/components';

export const ArticlePageTemplate = ({ title, helpByline, children }) => {
  const { sizes } = useTheme();

  return (
    <VStack
      bg="page.surface"
      p={4}
      mx="auto"
      width="100%"
      maxWidth={`calc(${sizes[1]} * 150)`}
      boxShadow="page"
      align="stretch"
      spacing={3}
    >
      <VStack as="header" spacing={1} align="stretch">
        <Heading size="3xl">{title}</Heading>
        {helpByline && <Text size="lg">{helpByline}</Text>}
      </VStack>
      {children}
    </VStack>
  );
};
